module.exports = __webpack_public_path__ + "static/media/icon8.659cc963.png";